module.exports = __webpack_public_path__ + "img/1f3b2.9dccc08.svg";